import { Box, ColorOptions, convertHexToRGBA, Loader, ModalDialog, ModBox, Spacer, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { Platform } from 'react-native'
import FileViewer from 'react-native-file-viewer'
import { DownloadFileModal } from '../../../comps/DownloadFileModal'
import { SvgImage } from '../../../comps/SvgImage'
import { TableComponent } from '../../../comps/TableComponent'
import { useLazyApiData, useStores } from '../../../data/store'
import { DeviceShare, openFileOnDevice } from '../../../util/permissions'
import { Colors, convertDate, DOWNLOAD_FAILED, FILE_DOWNLOADED, hasPermissions } from '../../../util/util'

export const ReportsList = ({ type, index }: any) => {
  const { fetchDownloadsListApiList, getDownloadReportData, reportType, pageNum, mid, downloadReportFile, setMessage } =
    useStores((store) => ({
      fetchDownloadsListApiList: store.reports.fetchDownloadsListApiList,
      getDownloadReportData: store.reports.getDownloadReportData,
      reportType: store.settings.metaData.downloadReportType,
      pageNum: store.reports.pagination.number,
      downloadReportFile: store.reports.downloadReportFile,
      mid: store.user.selectedMid,
      setDownloadReportType: store.settings.metaData.setDownloadReportType,
      setMessage: store.response.setMessage,
    }))
  const [fetchDownloadsListApi, { state }] = useLazyApiData(fetchDownloadsListApiList)
  const [downloadReportFileApi, { state: downloadApiState, data: downloadApiData }] = useLazyApiData(downloadReportFile)
  const [lastDownloadedData, setLastDownloadedData] = useState(undefined)

  const [showDownloadSuccessModal, setShowDownloadSuccessModal] = useState(false)
  const [selectedId, setSelectedId] = useState<string>()

  useEffect(() => {
    if (!!downloadApiData && downloadApiState !== 'pending') {
      if (downloadApiData?.code === FILE_DOWNLOADED || downloadApiData?.code === DOWNLOAD_FAILED) {
        setShowDownloadSuccessModal(true)
      }
    }
  }, [downloadApiState])
  useEffect(() => {
    if (type?.length > 0 && mid?.length > 0 && reportType?.toUpperCase() === type?.toUpperCase()) {
      fetchDownloadsListApi(pageNum, type.toUpperCase(), mid)
    }
  }, [index, reportType])

  const download = () => {
    if (lastDownloadedData) {
      downloadReportFileApi(lastDownloadedData?.requestId, reportType?.toUpperCase(), lastDownloadedData?.fileName)
    }
  }
  const getColor: any = {
    Complete: 'GREEN',
    'In Process': 'BRAND_PRIMARY_ORANGE',
    'In Progress': 'BRAND_PRIMARY_ORANGE',
    Failed: 'ERROR',
  }

  const checkPermissionAndDownload = async (data: any) => {
    if (downloadApiState !== 'pending') {
      setSelectedId(data?.requestId)
      hasPermissions().then((value) => {
        if (value) {
          downloadReportFileApi(data?.requestId, reportType?.toUpperCase(), data?.fileName)
          setLastDownloadedData(data)
        } else {
          setMessage('Permissions not granted')
        }
      })
    }
  }
  const renderItem = ({ item }: any) => {
    // TODO: the date format has be formated on the api call parse. Don't need to format
    const generatedDate = item?.requestTime
    return (
      <Box flexDirection={'row'} w={'100%'} bg={'WHITE'} pv={16}>
        <SvgImage color={Colors.SECONDARY} imageName="report" />
        <Box flexDirection={'row'} justify={'space-between'} f={1}>
          <Box f={0.9} pl={16} flexDirection={'column'}>
            <Text
              title={isEmpty(item?.fileName) ? 'NA' : item?.fileName}
              fontFamily={'JioType-Medium'}
              fontSize={14}
              numberOfLines={item.status === 'Complete' ? 1 : undefined}
              lineHeight={20}
              fontWeight={'600'}
              letterSpacing={-0.07}
              color={Colors.BLACK_14 as ColorOptions}
            />
            <Spacer size={2} direction={'vertical'} />
            <Text
              title={`${convertDate(item?.requestFrom)} to ${convertDate(item?.requestTo)}`}
              fontFamily={'JioType-Medium'}
              fontSize={12}
              lineHeight={16}
              letterSpacing={-0.07}
              fontWeight={'600'}
              color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
            />
            <Spacer size={2} direction={'vertical'} />
            <Text
              title={`${item.status === 'Complete' ? 'Generated at: ' : 'Requested at: '}${generatedDate}`}
              fontFamily={'JioType-Medium'}
              fontSize={12}
              lineHeight={18}
              fontWeight={'500'}
              letterSpacing={-0.07}
              color={convertHexToRGBA(Colors.BLACK, 50) as ColorOptions}
            />
          </Box>
          <Text
            fontFamily={'JioType-Medium'}
            fontSize={12}
            lineHeight={18}
            fontWeight={'500'}
            letterSpacing={-0.06}
            title={item.status}
            color={getColor[item.status] as ColorOptions}
            hide={item.status === 'Complete'}
          />
          <ModBox
            show={item.status === 'Complete'}
            testID="download-report-permission"
            onPress={() => checkPermissionAndDownload(item)}
            w={40}
            h={40}
            borderRadius={20}
            align={'center'}
            justify={'center'}
            bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
            underlayColor={'TRANSPARENT'}>
            {!(downloadApiState === 'pending' && selectedId === item?.requestId) && (
              <SvgImage imageName="Download" color={Colors.PRIMARY} />
            )}
            {downloadApiState === 'pending' && selectedId === item?.requestId && <Loader type={'small'} />}
          </ModBox>
        </Box>
      </Box>
    )
  }

  const share = async (path: any) => {
    // setShowDownloadSuccessModal(false)
    try {
      const shareOptions = {
        url: `file://'${path}`,
      }
      await DeviceShare(shareOptions)
      // setShowDownloadSuccessModal(false)
    } catch (error) {
      console.log(error)
      setShowDownloadSuccessModal(false)
    }
  }

  const openFile = async () => {
    if (downloadApiData?.code === 1 && !isEmpty(downloadApiData?.path)) {
      if (Platform.OS === 'ios') {
        FileViewer.open(downloadApiData?.path)
          .then(() => {
            // success
            // setShowDownloadSuccessModal(false)
          })
          .catch((_err) => {
            // error
            console.log(_err)
            setShowDownloadSuccessModal(false)
          })
      } else {
        try {
          openFileOnDevice(downloadApiData?.path, setMessage)
          setShowDownloadSuccessModal(false)
        } catch (err) {
          console.log(err)
          setShowDownloadSuccessModal(false)
        }
      }
    } else {
      download()
    }
  }

  const listData = getDownloadReportData()
  const isLoading = state === 'pending'
  return (
    <Box f={1} bg={'WHITE'} ph={24} pt={16}>
      {isLoading ? (
        <Box f={1} justify={'center'} align={'center'}>
          <Loader />
        </Box>
      ) : (
        <ModBox f={1} justify={'center'} align={'center'} show={state === 'rejected' || listData?.length === 0}>
          <Text title={'No Records found'} fontFamily={'JioType-Medium'} />
        </ModBox>
      )}
      <TableComponent
        flexForListContainer={1}
        customOnPress={() => {}}
        loadingState={false}
        isCustom={true}
        RenderCustomElement={renderItem}
        ListContent={listData}
        value={type}
        hide={state !== 'fulfilled' || isLoading}
      />
      <Spacer direction="vertical" size={24} />
      <ModBox
        align="center"
        justify="center"
        flexDirection={'row'}
        h={48}
        w={'100%'}
        borderWidth={1}
        show={!!state}
        underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
        testID="download-report"
        onPress={download}
        borderColor={'PRIMARY'}
        borderRadius={24}>
        <SvgImage imageName="RefreshIcon" color={Colors.PRIMARY} width={16} height={16} />
        <Spacer direction="horizontal" size={8} />
        <Text
          title={'Refresh'}
          fontFamily={'JioType-Medium'}
          fontSize={16}
          lineHeight={24}
          fontWeight={'600'}
          letterSpacing={-0.07}
          color={'PRIMARY'}
        />
      </ModBox>
      {showDownloadSuccessModal && (
        <ModalDialog show={showDownloadSuccessModal} type={'Bottom'}>
          <DownloadFileModal
            status={downloadApiData?.code}
            onPress={() => openFile()}
            onShare={() => share(downloadApiData?.path)}
            close={() => setShowDownloadSuccessModal(false)}
          />
        </ModalDialog>
      )}
    </Box>
  )
}
